<template>
    <div class="sdk-advert">
        <div class="breadcrumb">SDK广告管理</div>
        <div class="btn-box">
            <p class="title">当前SDK广告投放状态：{{isOpen?'已开启':'已关闭'}}</p>
            <div class="time-box" v-if="!showTimeInput && isOpen">
                <span>开放时间段：</span>
                <span v-if="startTime">{{startTime}} 至 {{endTime}}</span>

                <span v-else>全天</span>
                <span class="btn-edit" @click="showTimeInput = true">修改</span>
            </div>
            <div class="time-box" v-if="showTimeInput || !isOpen">
                <span>开放时间段：</span>
                <el-select class="my-time" v-model="startTime" clearable placeholder="开始时间">
                    <el-option v-for="item in startTimeList" :label="item" :value="item"></el-option>
                </el-select>
                至
                <el-select class="my-time" v-model="endTime" clearable placeholder="结束时间">
                    <el-option v-for="item in startTimeList" :label="item" :value="item"></el-option>
                </el-select>
                <span v-if="isOpen" class="btn-edit" @click="cancleSaveTime">取消</span>
                <span v-if="isOpen" class="btn-edit" @click="saveTime">保存</span>
            </div>
            <!-- <p class="title">当前SDK广告是否全屏：{{screenType=='1'?'是':'否'}}</p> -->
            <div class="screen-box">
                <span>是否全屏：</span>
                <el-radio class="radio" v-model="screenType" label="1">是</el-radio>
                <el-radio class="radio" v-model="screenType" label="0">否</el-radio>
                <span v-if="isOpen" class="btn-edit" @click="saveScreenType">保存</span>
            </div>
            <el-button type="primary" @click="toChangeOpening">{{isOpen?'一键关停':'一键开启'}}</el-button>
        </div>
    </div>
</template>
<script>
    export default {
        data() {
            return {
                isOpen: true,
                startTimeList: [
                    '00:00', '00:15', '00:30', '00:45',
                    '01:00', '01:15', '01:30', '01:45',
                    '02:00', '02:15', '02:30', '02:45',
                    '03:00', '03:15', '03:30', '03:45',
                    '04:00', '04:15', '04:30', '04:45',
                    '05:00', '05:15', '05:30', '05:45',
                    '06:00', '06:15', '06:30', '06:45',
                    '07:00', '07:15', '07:30', '07:45',
                    '08:00', '08:15', '08:30', '08:45',
                    '09:00', '09:15', '09:30', '09:45',
                    '10:00', '10:15', '10:30', '10:45',
                    '11:00', '11:15', '11:30', '11:45',
                    '12:00', '12:15', '12:30', '12:45',
                    '13:00', '13:15', '13:30', '13:45',
                    '14:00', '14:15', '14:30', '14:45',
                    '15:00', '15:15', '15:30', '15:45',
                    '16:00', '16:15', '16:30', '16:45',
                    '17:00', '17:15', '17:30', '17:45',
                    '18:00', '18:15', '18:30', '18:45',
                    '19:00', '19:15', '19:30', '19:45',
                    '20:00', '20:15', '20:30', '20:45',
                    '21:00', '21:15', '21:30', '21:45',
                    '22:00', '22:15', '22:30', '22:45',
                    '23:00', '23:15', '23:30', '23:45'
                ],
                endTimeList: [],
                startTime: '',
                endTime: '',
                screenType: '1',
                showTimeInput: false
            }
        },
        watch: {
            isOpen() {
                if (!this.isOpen) {
                    this.startTime = '';
                    this.endTime = ''
                }
            },
        },
        mounted() {
            this.getSDKOpenInfo();
            // this.endTimeList = [...this.startTimeList];
            // this.endTimeList.shift();
            // this.endTimeList.push('00:00');
        },
        methods: {
            getSDKOpenInfo() {
                let url = this.$util.domain + '/adminapi/v2/ad/getSDKAdStatus';
                this.$http({
                    url,
                    method: "GET",
                }).then(res => {
                    if (res.data.error == 10000) {
                        let preObj = res.data.data;
                        this.isOpen = preObj.isOpen == 1 ? true : false;
                        this.screenType = preObj.type == 1 ? '1' : '0';
                        this.startTime = this.formatTime(preObj.startTime);
                        this.endTime = this.formatTime(preObj.endTime);
                    }
                })
            },
            formatTime(time) {
                let rtime = '';
                if (time) {
                    rtime = time.split(':')[0] + ':' + time.split(':')[1]
                }
                return rtime
            },
            toChangeOpening() {
                let url = this.$util.domain + '/adminapi/v2/ad/openSDKAd';
                let message = '确认要一键开启SDK广告投放吗？开启后所有页面及学校都将开始投放。'
                if (this.isOpen) {
                    message = '确认要一键关停SDK广告投放吗？关停后所有页面及学校都将停止投放。'
                    this.startTime = '';
                    this.endTime = '';
                }

                let type = this.isOpen ? 0 : 1;
                if ((type == 1 && this.endTime && !this.startTime) || (type == 1 && !this.endTime && this.startTime)) {
                    return this.$util.errorMsg('开放时间段填写不完整！')
                }

                this.$confirm(message, '温馨提示').then(res => {
                    this.sendReqHttp(type)
                })
            },

            saveTime() {
                if ((this.endTime && this.startTime) || (!this.endTime && !this.startTime)) {
                    this.$confirm('确定修改开放时间段吗？', '温馨提示').then(res => {
                        this.sendReqHttp(1)
                        this.showTimeInput = false
                    }).catch(_ => {
                        this.getSDKOpenInfo();
                        this.showTimeInput = false
                    })
                } else {
                    this.$util.errorMsg('开放时间段填写不完整！')
                }

            },
            saveScreenType() {
                this.$confirm('确定修改全屏设置吗？', '温馨提示').then(res => {
                    let type = this.isOpen ? 1 : 0;
                    this.sendReqHttp(type);
                }).catch(_ => {
                    this.getSDKOpenInfo();
                })
            },

            cancleSaveTime() {
                this.getSDKOpenInfo();
                this.showTimeInput = false
            },

            sendReqHttp(type) {
                let url = this.$util.domain + '/adminapi/v2/ad/openSDKAd';
                this.$http({
                    url,
                    method: "POST",
                    body: JSON.stringify({
                        isOpen: type, // 0: 关闭，1：开启
                        type: this.screenType,
                        startTime: this.startTime ? this.startTime + ':00' : null,
                        endTime: this.endTime ? this.endTime + ':00' : null
                    })
                }).then(res => {
                    if (res.data.error == 10000) {
                        this.$util.successMsg('操作成功！')
                        this.getSDKOpenInfo();
                    } else {
                        this.$util.errorMsg(res.data.message)
                    }
                })
            }
        }
    }
</script>
<style scoped>
    .sdk-advert .btn-box {
        padding-top: 100px;
        text-align: center;
    }

    .sdk-advert .title {
        margin-bottom: 20px;
    }

    .time-box {
        margin-bottom: 20px;
    }

    .screen-box {
        margin-bottom: 20px;
    }

    .my-time {
        display: inline-block;
        width: 120px;
    }

    .btn-edit {
        color: #01a6ef;
        cursor: pointer;
        margin-left: 15px;
    }
</style>


// WEBPACK FOOTER //
// sdkAdvert.vue?272148ec